module.exports = __webpack_public_path__ + "img/178.8aee2676.jpg";